import { render } from "./P089.vue?vue&type=template&id=7a6052a2&scoped=true"
import script from "./P089.vue?vue&type=script&lang=js"
export * from "./P089.vue?vue&type=script&lang=js"

import "./P089.vue?vue&type=style&index=0&id=7a6052a2&scoped=true&lang=css"

import exportComponent from "/home/sage/workspace/sageprice-dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a6052a2"]])

export default __exports__